module.exports = "/fonts/vendor/@fontsource/roboto/files/roboto-latin-300-normal.woff2?c48fb6765a9fcb00b3300fee318b45df";